import { ENERGY_CERTIFICATION_LABEL_SIZES } from '@spa/shared/constants/energyCertificationLabelSizes';
import styled from 'styled-components';

const { small, large } = ENERGY_CERTIFICATION_LABEL_SIZES;

const getBackgroundColor = grade => {
  const gradeColorMap = {
    'a++++': 'var(--grade-aPlus)',
    'a+++': 'var(--grade-aPlus)',
    'a++': 'var(--grade-aPlus)',
    'a+': 'var(--grade-aPlus)',
    a: 'var(--grade-a)',
    b: 'var(--grade-b)',
    'b-': 'var(--grade-bMinus)',
    c: 'var(--grade-c)',
    d: 'var(--grade-d)',
    e: 'var(--grade-e)',
    f: 'var(--grade-f)',
    g: 'var(--grade-g)'
  };
  return gradeColorMap[grade];
};

export const Wrapper = styled.span`
  --grade-aPlus: ${props => props.theme.energyCertification.backgrounds.gradeAPlus};
  --grade-a: ${props => props.theme.energyCertification.backgrounds.gradeA};
  --grade-b: ${props => props.theme.energyCertification.backgrounds.gradeB};
  --grade-bMinus: ${props => props.theme.energyCertification.backgrounds.gradeBMinus};
  --grade-c: ${props => props.theme.energyCertification.backgrounds.gradeC};
  --grade-d: ${props => props.theme.energyCertification.backgrounds.gradeD};
  --grade-e: ${props => props.theme.energyCertification.backgrounds.gradeE};
  --grade-f: ${props => props.theme.energyCertification.backgrounds.gradeF};
  --grade-g: ${props => props.theme.energyCertification.backgrounds.gradeG};

  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: ${props => props.theme.space(1)} ${props => props.theme.space(2)};
  height: 28px;
  border-radius: 100vh;
  background-color: ${props => getBackgroundColor(props.grade)};
  font-family: 'IntervalNextReg', sans-serif;
  font-size: ${props => props.theme.rem(16)};
  line-height: ${props => props.theme.rem(20)};
  text-transform: uppercase;
  color: ${props => props.theme.typography.invertedColor};

  ${({ size }) => size === small && 'width: 56px;'}

  ${({ size }) => size === large && 'width: 80px;'}
`;
